import React from "react";
import styled from "styled-components";
import { color } from "../templates/ui";
const RADIO_COLOR = "#601E6F";
const RadioGroupWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
const RadioInput = styled.input `
  appearance: none;
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid ${RADIO_COLOR};
  border-radius: 0.25rem;
  position: relative;
  cursor: pointer;
  flex-shrink: 0;

  &:checked {
    background-color: ${RADIO_COLOR};
    border-color: ${RADIO_COLOR};
  }

  &:checked:after {
    content: "✓";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 0.875rem;
    font-weight: bold;
    line-height: 1;
  }
`;
const RadioLabel = styled.label `
  cursor: pointer;
  width: 100%;
`;
const Title = styled.span `
  font-family: ${props => props.theme.fontHead};
  font-weight: 700;
  font-size: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${props => props.theme.textBase};
  margin-bottom: 0.25rem;
`;
const Description = styled.span `
  font-family: ${props => props.theme.fontBase};
  font-size: 0.875rem;
  color: ${color.gray.dark};
`;
const RadioItem = styled.div `
  padding: 0.75rem 1rem;
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  border-radius: 0.375rem;
  border: 1px solid ${props => props.theme.border};
  background-color: ${color.gray.light};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  pointer-events: ${props => (props.disabled ? "none" : "auto")};
  transition: all 0.2s ease-in-out;

  ${props => props.checked
    ? `
    background-color: ${RADIO_COLOR};
    border-color: ${RADIO_COLOR};
    
    ${Title} {
      color: #fff;
    }
    
    ${Description} {
      color: rgba(255, 255, 255, 0.9);
    }
  `
    : `
    border-color: ${props.theme.border};
    
    ${Title} {
      color: ${RADIO_COLOR};
    }
  `};
`;
const RadioGroup = ({ name, options, selectedValue, onChange, className, }) => (React.createElement(RadioGroupWrapper, { className: className }, options.map(option => (React.createElement(RadioItem, { key: option.id, checked: selectedValue === option.id, disabled: option.disabled, onClick: () => !option.disabled && onChange(option.id) },
    React.createElement(RadioInput, { type: "radio", id: option.id, name: name, checked: selectedValue === option.id, onChange: () => onChange(option.id) }),
    React.createElement(RadioLabel, { htmlFor: option.id },
        React.createElement(Title, null, option.title),
        option.description && (React.createElement(Description, null, option.description))))))));
export default RadioGroup;
